export const whyChoose = () => {

};



// WEBPACK FOOTER //
// ./src/templates/components/why-choose/why-choose.js